module.exports = __webpack_public_path__ + "static/fair-harbor@fiferries.926613a9.jpg";